import React from 'react';

import { Link } from 'gatsby';
import logo from '../../images/elch_logo.svg';

import './styles.scss';

const ELChLogo = ({ isLink = true, className }: { isLink: boolean; className?: string }) => {
  return (
    <div className="elchLogo">
      {isLink ? (
        <Link to="/">
          <span className="elch">ELCh</span> <span className="digital">Digital</span>
        </Link>
      ) : (
        <div className={className}>
          <img width={350} height={350} src={logo} alt="ELCh Digital Logo" />
        </div>
      )}
    </div>
  );
};

export default ELChLogo;
